// Webpack Imports
import * as bootstrap from 'bootstrap';
import $ from "jquery";


import { Test } from './js/test';

$(document).ready(function() {

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


$('.js-langMobile-open').on('click', function () {
	let nbm = $('#navbar-mobile');

	if (nbm.hasClass('opened')) {
		nbm.animate({
			marginTop: 0,
		}, 1000, function() {
			$(this).removeClass('opened');
		});
	} else {
		nbm.animate({
			marginTop: (-1 * ($(window).height() - 64)),
		}, 1000, function() {
			$(this).addClass('opened');
		});
	}
});


$('.js-langDesktop-open').on('click', function () {
	let ld = $('.langDesktop');

	$(this).css('z-index', 25000);

	if (ld.hasClass('opened')) {
		ld.fadeOut(400, function() {
			$(this).removeClass('opened');
		});
	} else {
		ld.fadeIn(300, function() {
			$(this).addClass('opened');
			
		});
	}
});



$('.js-closeMenu').on('click', function () {
	$('#navbar-mobile').fadeOut(400);
});

$('.js-openMenu').on('click', function () {
	$('#navbar-mobile').fadeIn(400);
});

var collapseBox = document.querySelectorAll('.collapseBox');

collapseBox.forEach(function (el) {
	var opener = el.querySelector('.collapseBox__opener');
	var content = el.querySelector('.collapseBox__content');
	
  	opener.addEventListener('click', function (e) {
			e.target.classList.toggle('opened');
			content.classList.toggle('show');
			
	});
});



$('.video').on('click', function( event ) {
	if($(event.target).hasClass('video')) {
		$(this).fadeOut();
	}
});

$('.play_video').on('click', function( event ) {
	const video = $(this).attr('data-video');
	const video_player = $('#' + video );

	console.log(video);
	console.log(video_player);

	video_player.fadeIn();
});

});

